/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 16 16" }, this.props),
            React.createElement("path", { d: "m8.5.0003c3.7884167 0 6.5 2.959 6.5 6.609 0 4.869-5.733 9.391-6.5 9.391-.74425 0-6.5-4.522-6.5-9.391 0-3.65 2.7105-6.609 6.5-6.609zm0 10c1.9332433 0 3.5-1.56762973 3.5-3.50050309 0-1.93186718-1.5667567-3.49949691-3.5-3.49949691-1.93324332 0-3.5 1.56762973-3.5 3.49949691 0 1.93287336 1.56675668 3.50050309 3.5 3.50050309z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;